import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import useQueryBoard from "../../../lib/hooks/useQueryBoard";

interface AgreementValue {
  screen: string;
  showFirst: boolean;
  unacceptedAgreements?: IEntranceAgreementFile[];
}

export const useAgreementState = (): AgreementValue => {
  const { data } = useQueryBoard();
  const { state } = useLocation();

  const entranceAgreement = data?.digitalReception?.entranceAgreement;

  const showFirst = entranceAgreement?.showFirst ?? false;

  const unacceptedAgreements = !entranceAgreement?.disabled
    ? entranceAgreement?.files?.filter((file) => !file.disabled)
    : [];

  const value = useMemo((): AgreementValue => {
    return {
      screen: data?.digitalReception?.id || "",
      showFirst,
      unacceptedAgreements,
    };
  }, [state, unacceptedAgreements, data]);

  return value;
};
